import { hash32, seedFromString } from '@gardener/core';
import * as air from './air';
import * as bots from './bots';
import * as cars from './cars';
import * as characters from './characters';
import * as config from './config';
import * as creeps from './creeps';
import * as economy from './economy';
import * as fishing from './fishing';
import * as minions from './minions';
import * as modes from './modes';
import * as royale from './royale';
import * as targets from './targets';
import * as vision from './vision';
import * as weapons from './weapons';
import * as zombies from './zombies';

/** The balance: every tuning table the game plays by (maps and code changes come with the build's git sha). */
const TABLES: readonly object[] = [
  air,
  bots,
  cars,
  characters,
  config,
  creeps,
  economy,
  fishing,
  minions,
  modes,
  royale,
  targets,
  vision,
  weapons,
  zombies,
];

const f64 = new Float64Array(1);
const u32 = new Uint32Array(f64.buffer);

/**
 * The balance's fingerprint (ADR-0042): `hash32` over every number and flag of the tuning tables (and of `extra`
 * tables, the bots' level curve from `@gardener/match`'s `balanceHash`), each with the path of keys that leads to it,
 * read when called — so a value edited at run time (the arena's `--patch`) makes a new one too. Text (names, captions,
 * tutorial copy) is not balance and is left out. Rounds are stored with it, so a balance tweak is a "patch" of its own
 * even within one build. 8 hex digits.
 */
export function contentHash(extra: readonly object[] = []): string {
  let h = 0;
  const seen = new Set<object>();
  const visit = (v: unknown, path: number): void => {
    if (typeof v === 'number') {
      f64[0] = v;
      h = hash32(h, path, u32[0] as number, u32[1] as number);
    } else if (typeof v === 'boolean') h = hash32(h, path, v ? 1 : 2);
    else if (typeof v === 'object' && v !== null && !seen.has(v)) {
      seen.add(v);
      for (const [key, value] of Object.entries(v)) visit(value, hash32(path, seedFromString(key)));
    }
  };
  for (const t of [...TABLES, ...extra]) visit(t, 0);
  return h.toString(16).padStart(8, '0');
}
